import {
    handleRehydrateAction,
    handleRemoveAction,
    handleSubmitAction
} from '../../../core/store/helpers/reducer-helper';
import { BaseObjectFilters } from '../../store/base-object-filters';
import * as actions from './category-group.actions';
import { CategoryGroup } from './category-group.model';

export interface State {
    ids: Array<string>;
    entities: {[id: string]: CategoryGroup};
    filters: BaseObjectFilters;
}

export const initialState: State = {
    ids: [],
    entities: {},
    filters: {
        searchTerm: '',
        sortDirection: 0,
        sortBy: 'id'
    }
};

// tslint:disable-next-line:only-arrow-functions
export function reducer(state = initialState, action: actions.Actions): State {
    switch (action.type) {
        case actions.SUBMIT: {
            return handleSubmitAction(state, action);
        }
        case actions.REHYDRATE: {
            return handleRehydrateAction(state, action);
        }
        case actions.REMOVE: {
            return handleRemoveAction(state, action);
        }
        default: {
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/category-group/category-group.reducer.ts